/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Event } from './event';
import { EventData } from './event-data';
import { LocationInstance } from './location-instance';
import { Point } from './point';
import { ObjectInstance } from './object-instance';
import { ZoneInstance } from './zone-instance';

export class EventInstance {
  id: number;
  event: Event;
  person: ObjectInstance;
  locationInstance: LocationInstance;
  zoneInstance: ZoneInstance;
  name: string;
  uuid: string;
  point: Point;
  creationDate: Date;
  data: EventData[];
}
